import { Component, OnInit } from "@angular/core";
import { AuthService } from "../auth.service";
import { DataServiceService } from "../data-service.service";
import { User } from "../model/login";

@Component({
  selector: "app-setting",
  templateUrl: "./setting.component.html",
  styleUrls: ["./setting.component.scss"],
})
export class SettingComponent implements OnInit {
  userDetails: User;
  isLoading: boolean = true;
  creditInfo: CreditInfo;

  constructor(
    private dataService: DataServiceService,
    private authService: AuthService
  ) {}

  async ngOnInit() {
    this.getUserDetails().then((data) => {
      this.getCreditInfo().then(() => {
        this.isLoading = false;
      });
    });
  }

  async getUserDetails() {
    this.userDetails = await this.dataService.getUserDetailsById(
      this.authService.getCurrentUser().userId
    );
    this.userDetails = this.userDetails[0];
  }

  async getCreditInfo() {
    this.creditInfo = await this.dataService.getCreditInfo();
  }

  isAdverseMediaEnabled(user: User) {
    return user && user.isAdverseMediaEnabled === true;
  }
}
